<template>
    <div class="modal-container" :class="[{show:showModal},modalParams.class]">
        <div class="overlay" @click="handleCloseModal"></div>
        <div class="modal" :style="'height:'+modalParams.height+';width:'+modalParams.width">
            <h3 v-if="modalParams.title">
                <span v-html="modalParams.title"></span>
                <font-awesome-icon icon="times" @click="handleCloseModal"/>
            </h3>
            <div style="display: none" class="close-btn" @click="handleCloseModal">
                <font-awesome-icon icon="times"/>
            </div>
            <div class="modal-content-container" id="modalContent">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'

    import {mapState, mapGetters,mapMutations} from 'vuex'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {
            ...mapState({

            }),
            ...mapGetters({
                showModal: 'UI/showModal',
                modalParams: 'UI/modalParams'
            })
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            ...mapMutations({
                handleCloseModal: 'UI/closeModal'
            })
        },
        mounted: function () {

        },
        name: '',
        props: {
        },
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">

    .modal-container {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10000000000;
        height: 100%;
        width: 100%;
        opacity: 0;
        pointer-events: none;

        .overlay {
            height: 100%;
            width: 100%;
            background-color: rgba($main-color, 0.6);
        }

        .modal {
            background-color: $main-white;
            position: absolute;
            top: 50%;
            left: 50%;
            max-height: calc(100% - 20px);
            max-width: calc(100% - 20px);
            min-width: 520px;
            //height: calc(100% - 20px);
            padding: 20px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.2);
            transform: translate(-50%,-100vh);
            transition-duration: 500ms;
            transition-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1.1);
            //border: solid 1px $main-white;

            h3 {
                color: $main-color;
                margin: 0 0 20px;

                .svg-inline--fa{
                    float:right;
                    cursor: pointer;
                }
            }

            .modal-content-container{
                height: calc(100% - 40px);
                overflow: auto;
                padding: 0 20px;
                margin: 0 -20px;
            }

            &.danger{
                border: solid 10px $error;

                h3 {
                    color: $error;
                }
            }


        }

        &.plugin-modal{
            .modal{
                border: solid 10px $main-color;

                .close-btn{
                    cursor: pointer;
                    position: absolute;
                    right: -10px;
                    top: -10px;
                    background-color: $main-color;
                    color: $main-white;
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                }

                .modal-content-container{

                    height: calc(100% - 40px);
                    overflow: auto;
                    padding: 0px 20px;
                    margin: 0 -20px;


                }
            }
        }

        &.show {
            opacity: 1;
            pointer-events: auto;

            .modal{
                transform: translate(-50%,-50%);
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/ui/Modal.vue